import React, { useState } from "react";
import { Row, Col, FormGroup } from "reactstrap";
import { useDispatch } from "react-redux";

import { useFormik } from "formik";
import * as Yup from "yup";
import { Loader } from "../Utils/Loader";
import { toast } from "react-toastify";

import { LabelText } from "../Utils/Input";
import InputField from "../Utils/InputField";
import CommonButton from "../Utils/CommonButton";

import { stockinCreationPO } from "../../slices/PO/StockinCreate/thunk";
import { approvedRequestPO } from "../../slices/PO/ApprovedRequestPO/thunk";

function POStockInForm({ closeModal, stockInData, refreshPOList }) {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      itemName: stockInData?.itemName || "",
      itemId: stockInData?.itemId || "",
      sku: stockInData?.sku || "",
      quantity: Number(stockInData?.quantity || 0),
      stockInQty: Number(stockInData?.stockInQty ?? 0),
      toLocation: stockInData?.toLocation || "",
    },

    enableReinitialize: true,

    validationSchema: Yup.object({
      stockInQty: Yup.number()
        .typeError("Stock In Quantity must be a number")
        .required("Stock In Quantity is required")
        .min(1, "Minimum 1"),
    }),

    onSubmit: (values) => {
      if (Number(values.stockInQty) > Number(stockInData?.stockInQty)) {
        toast.error(
          "Stock In Quantity cannot be greater than Approved Quantity",
        );
        return;
      }

      const payload = {
        itemid: values.itemId,
        stockinquantity: Number(values.stockInQty),
        transactiontype: "stockin",
        tolocation: stockInData.tolocationId,
      };

      dispatch(
        stockinCreationPO(stockInData?.poNumber, payload, setLoading, () => {
          dispatch(
            approvedRequestPO(
              { status: "completed" },
              stockInData?.poNumber,
              values.itemId,
              setLoading,
              () => {
                refreshPOList?.();
                closeModal();
              },
            ),
          );
        }),
      );
    },
  });

  const { values, errors, touched, handleChange, handleSubmit } = formik;

  return (
    <>
      {loading && <Loader />}
      <form onSubmit={handleSubmit}>
        <Row className="gy-3">
          {/* ITEM NAME */}
          <Col md={6}>
            <FormGroup>
              <LabelText displayText="Product Name" />

              <InputField value={values.itemName} disabled />
            </FormGroup>
          </Col>

          {/* ITEM ID */}
          <Col md={6}>
            <FormGroup>
              <LabelText displayText="Product ID" />

              <InputField value={values.itemId} disabled />
            </FormGroup>
          </Col>

          {/* SKU */}
          <Col md={6}>
            <FormGroup>
              <LabelText displayText="SKU" />

              <InputField value={values.sku} disabled />
            </FormGroup>
          </Col>

          {/* QUANTITY */}
          <Col md={6}>
            <FormGroup>
              <LabelText displayText="Available Quantity" />

              <InputField value={values.quantity} disabled />
            </FormGroup>
          </Col>

          {/* TO LOCATION */}
          <Col md={6}>
            <FormGroup>
              <LabelText displayText="To Location" />

              <InputField value={values.toLocation} disabled />
            </FormGroup>
          </Col>

          {/* STOCK IN QTY */}
          <Col md={6}>
            <FormGroup>
              <LabelText
                displayText="Stock In Quantity"
                className={"text-danger"}
                important={"*"}
              />

              <InputField
                name="stockInQty"
                type="text"
                placeholder="Enter Quantity"
                value={values.stockInQty}
                handleChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) {
                    formik.setFieldValue("stockInQty", value);
                  }
                }}
                invalid={touched.stockInQty && errors.stockInQty}
              />
            </FormGroup>
          </Col>

          <div className="d-flex justify-content-center w-100 gap-2 flex-wrap pe-1 pb-1 mt-4">
            <div className="d-flex gap-2 justify-content-center">
              <CommonButton
                outline={true}
                className={
                  "btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
                }
                color={"main-color"}
                type={"reset"}
                buttonAction={() => {
                  closeModal();
                }}
                buttonText={"Cancel"}
                icon={
                  <i className="ri-close-fill label-icon secondary-label-icon align-middle fs-16 me-2"></i>
                }
                btnTxtClsName={"px-2 ps-3 ms-2 me-1 fw-bold"}
              />

              <CommonButton
                color={"main-color"}
                className={
                  "btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
                }
                icon={
                  <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-2"></i>
                }
                btnTxtClsName={"px-2 ps-3 ms-2 me-1 fw-bold"}
                type={"submit"}
                buttonText={"Submit"}
                buttonAction={handleSubmit}
                disabled={loading}
              />
            </div>
          </div>
        </Row>
      </form>
    </>
  );
}

export default POStockInForm;
